/* eslint-disable no-new */
import Flickity from "flickity"
const featuredElements = Array.from(document.querySelectorAll(".js-featured-flickity"))
featuredElements.forEach((featured) => {
	const slider = new Flickity(featured, {
		wrapAround: true,
	})
	const prevTriggers = Array.from(featured.querySelectorAll(".js-featured-prev"))
	const nextTriggers = Array.from(featured.querySelectorAll(".js-featured-next"))
	prevTriggers.forEach((prev) => {
		prev.addEventListener("click", () => slider.previous())
	})
	nextTriggers.forEach((next) => {
		next.addEventListener("click", () => slider.next())
	})
})